import { Component, OnInit } from '@angular/core';
import { FormButton } from '../../../core/components/form-field-button/form-field-button.component';
import { Item } from '../../../core/components/listbox/listbox.component';
import { DataTaskService } from '../../../core/services/data-task.service';
import { ModalService } from '../../../core/services/modal.service';
import { StateService } from '../../../core/services/state.service';

@Component({
  selector: 'tt-oh-direct-delivery',
  templateUrl: './oh-direct-delivery.component.html',
  styleUrls: ['./oh-direct-delivery.component.css']
})
export class OhDirectDeliveryComponent implements OnInit {
    orderInternalNo;

    public amountPaidBeforeButtons: FormButton[] = [
        {
            id: 'goto',
            type: 'primary',
            icon: 'fas fa-chevron-right',
            goto: 'prepayments',
            gotoParms: () => ({
                argtype: 'order_internal_no',
                argvalue: this.setting!.order_internal_no
            })
        }
    ];

    public setting?: Setting;

    public itemsListDirectDeliveries: Item[] = [];

    public showSelectAll = false;

    public showUnSelectAll = false;

    public delivering = false;

    constructor(private stateService: StateService, private modal: ModalService, private datatask: DataTaskService) {
        this.orderInternalNo = this.stateService.getStateParams()['order_internal_no'];
    }

    private async loadSetting() {
        if (!!this.orderInternalNo) {
            this.setting = (await this.datatask.Post(1694, { order_internal_no: this.orderInternalNo }))[0];
        }
    }

    private async loadDirectDeliveries() {
        if (!this.setting) return;

        this.itemsListDirectDeliveries = await this.datatask.Post(1695, this.setting);

        this.itemsListDirectDeliveries.forEach((item: any) => {
            if (item.item_id === '0' || item.item_id === '-1') return;

            if (item.item_is_selected === '1') {
                this.showSelectAll = false;
                this.showUnSelectAll = true;
            } else {
                this.showSelectAll = true;
                this.showUnSelectAll = false;
            }
        });
    }

    public selectAll() {
        this.itemsListDirectDeliveries.forEach((item: any) => {
            if (item.item_id === '0' || item.item_id === '-1') return;

            item.item_is_selected = '1';
            this.showSelectAll = false;
            this.showUnSelectAll = true;
        });
    }

    public unselectAll() {
        this.itemsListDirectDeliveries.forEach((item: any) => {
            if (item.item_id === '0' || item.item_id === '-1') return;

            item.item_is_selected = '0';
            this.showSelectAll = true;
            this.showUnSelectAll = false;
        });
    }

    toggleChosen(item: any): void {
        item = item?.item ? item.item : item;

        if (item.item_id === '0' || item.item_id === '-1') return;

        if (item.item_is_selected === '0') {
            item.item_is_selected = '1';
        } else if (item.item_is_selected === '1') {
            item.item_is_selected = '0';
        }
    }

    public async deliverChanges() {
        if (!!this.setting) {
            try {
                this.delivering = true;

                const selectedItems = (this.itemsListDirectDeliveries ?? [])
                    .filter((row) => row['item_id'] !== '0' && row['item_is_selected'] === '1')
                    .map((row) => ({
                        item_id: row['item_id'],
                        item_name: row['item_name'],
                        item_is_selected: row['item_is_selected']
                    }));
                
                const mergeObj = {
                    order_internal_no: this.setting.order_internal_no,
                    records: selectedItems
                }

                const response = (await this.datatask.Post(1696, mergeObj))[0];

                if (response?.errorcode !== '0') {
                    this.modal.show({
                        type: 'warning',
                        title: 'error',
                        translateTitle: true,
                        message: response.errormessage
                    });
                } else {
                    this.stateService.back();
                }
            } finally {
                this.delivering = false;
            }
        }
    }

    private async init() {
        await this.loadSetting();
        this.loadDirectDeliveries();
    }

    ngOnInit() {
        this.init();
    }
}

interface Setting {
    webpage_heading: string;
    order_internal_no: string;
    searchtext: string;
    show_setting: string;
    amount_paid_before: string;
    amount_total_topay: string;
    amount_topay_rest: string;
    text_topay_rest: string;
}
